import {
  LoggerProvider,
  transportConsole,
  transportSentry,
} from "@kensho/lumberjack";
import { NeoProvider } from "@kensho/neo";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Outlet, useNavigate } from "react-router";

import { queryClient } from "../app/query-client";
import { CookieConsentPopup } from "../components/cookie-banner/cookie-consent-popup";
import { SiteAnalyticsProvider } from "../providers/site-analytics-provider";
import { UserProvider } from "../providers/user-provider";

const transports = import.meta.env.PROD
  ? [transportSentry({ levels: ["error", "warning"] }), transportConsole()]
  : [transportConsole()];

export function Root() {
  const navigate = useNavigate();
  return (
    <LoggerProvider transports={transports}>
      <QueryClientProvider client={queryClient}>
        <NeoProvider navigate={navigate}>
          <ReactQueryDevtools buttonPosition="bottom-left" />
          <SiteAnalyticsProvider>
            <CookieConsentPopup />
            <UserProvider>
              <Outlet />
            </UserProvider>
          </SiteAnalyticsProvider>
        </NeoProvider>
      </QueryClientProvider>
    </LoggerProvider>
  );
}
